import React, { useRef } from "react";
import {
  IonButton,
  IonText,
  IonDatetime,
  IonContent,
  IonButtons,
  IonLabel,
  useIonModal,
} from "@ionic/react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { setMonth } from "../features/visits/visitsSlice";
import moment from "moment";

const MonthYearPicker = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const customDatetime = useRef();
  const { activeMonth } = useSelector((state) => state.visits);
  let date = moment(activeMonth).format("MMMM YYYY");

  const confirm = () => {
    if (customDatetime === undefined) return;
    handleDismiss();
    customDatetime.current.confirm();
  };

  const handleDismiss = () => {
    dismiss();
  };

  const onChangeDate = (changedDate) => {
    dispatch(setMonth(moment(changedDate).startOf("month").format()));
  };

  const [present, dismiss] = useIonModal(
    <IonContent force-overscroll="false">
      <div style={{ padding: "8px 16px" }}>
        <IonLabel>
          {intl.formatMessage({
            id: "app.mobile.choose_month",
          })}
        </IonLabel>
      </div>

      <IonDatetime
        presentation={"month-year"}
        onIonChange={(e) => onChangeDate(e.detail.value)}
        locale="he-IL"
        ref={customDatetime}
        value={moment(activeMonth).format()}
        max="2032-05-31T23:59:59"
      >
        <IonButtons slot="buttons">
          <IonButton onClick={() => handleDismiss()}>
            {intl.formatMessage({
              id: "app.mobile.actions.cancel",
            })}
          </IonButton>
          <IonButton
            fill="solid"
            size="large"
            onClick={() => {
              confirm();
            }}
          >
            {intl.formatMessage({
              id: "app.mobile.actions.approve",
            })}
          </IonButton>
        </IonButtons>
      </IonDatetime>
    </IonContent>,

    {
      onDismiss: handleDismiss,
    }
  );

  return (
    <div className="month-picker-button">
      <IonButton
        fill="clear"
        onClick={() => {
          present({
            backdropDismiss: true,
            showBackdrop: true,
            cssClass: "month-picker-modal",
          });
        }}
      >
        <IonText slot="end">
          <label>{date}</label>
        </IonText>
      </IonButton>
    </div>
  );
};

export default MonthYearPicker;
